"use strict";
/*globals Highcharts:false, BaseAPI: false */

/**
 * Cette classe facilite la génération de SVG.
 *
 * Exemple d'utilisation :
 *
 * var builder = new SVGBuilder(300, 170);
 * builder.fillRect(10, 10, 290, 160, 'red');
 * builder.triangle(10, 10, 290, 85, 10, 160, 'blue');
 * builder.circle(290, 85, 10, 'green');
 * builder.done();
 * builder.outputIMG(container);
 */
function SVGBuilder(width, height) {
	// "version" et "xmlns" servent à générer du XML valide
	// "time" permet de gérer des dataURL unique pour éviter que l'image ne soit mise en cache afin de rejouer les animations
	this.svg = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" time="' + Date.now() + '" width="' + width + '" height="' + height + '">';
}

/**
 * Cette méthode "bas-niveau" :
 * - ouvre un tag
 * - renseigne les attributs donnés
 * - ajoute le contenu (string/fonction/array)
 * - et enfin ferme le tag
 * L'avantage de cette méthode plutôt que startTag ... endTag est de s'assurer qu'un tag ouvert est automatiquement fermé.
 */
SVGBuilder.prototype.tag = function(tag, attributes, content) {
	this.svg += '<' + tag;
	for (var attribute in attributes) {
		if (attributes.hasOwnProperty(attribute))
			this.svg += ' ' + attribute + '="' + attributes[attribute] + '"';
	}
	if (content) {
		this.svg += '>';
		this.append(content);
		this.svg += '</' + tag + '>';
	} else {
		this.svg += '/>';
	}
};

/**
 * Cette méthode ajoute le contenu demandé, qui peut être :
 * - un texte
 * - une fonction sans argument et sans retour
 * - un tableau de texte et/ou de fonction
 * Elle doit donc être utilisée avec précaution.
 */
SVGBuilder.prototype.append = function(content) {
	if (typeof content === 'string')
		this.svg += content;
	else if (typeof content === 'function')
		content();
	else if (content instanceof Array)
		content.forEach(this.append.bind(this));
	else if (typeof content !== 'undefined')
		throw new Error('Contenu non supporté ' + content);
};

/**
 * Cette méthode doit être appelée une fois que le contenu du SVG a été généré afin de fermer le document.
 * Cette appel est généralement suivi de :
 * - builder.outputSVG(dom) pour injecter le SVG tel quel dans l'arbre DOM
 * - builder.outputIMG(dom) pour injecter une image contenant le SVG
 */
SVGBuilder.prototype.done = function() {
	this.svg += '</svg>';
};

/**
 * Cette méthode injecte le SVG généré dans le conteneur donné "container".
 * - l'avantage de cette méthode est que le SVG apparait dans l'arbre DOM
 * - l'inconvénient de cette méthode est que la copie d'image par clic-droit n'est pas dispo
 */
SVGBuilder.prototype.outputSVG = function(container) {
	container.innerHTML = this.svg;
};

/**
 * Cette méthode injecte le SVG généré dans l'URL d'un tag "img" ajouté au conteneur "container".
 * - l'avantage de cette méthode est de faciliter la copie de l'image par clic-droit
 * - l'inconvénient de cette méthode est d'exclure le SVG de l'arbre DOM
 */
SVGBuilder.prototype.outputIMG = function(container) {
	var xml = this.svg; //new XMLSerializer().serializeToString(dom);
	var url = 'data:image/svg+xml;base64,' + btoa(xml);
	container.innerHTML = '<img src="' + url + '" />';
};

/**
 * Cette méthode remplace les caractères interdits en SVG/XML par leur entité XML équivalente.
 * Par exemple : "€" est remplacé par "&#8364;".
 * Voir ici les entités : https://www.w3schools.com/html/html_entities.asp
 */
SVGBuilder.prototype.escapeText = function(text) {
	var t = text;
	// Remplacer le symbole € par sa représentation XML (sinon, passe pour outputSVG mais plante pour outputIMG)
	t = t.replace('€', '&#8364;');
	return t;
};

/**
 * Cette méthode vient compléter le fonctionnement de la fonction "outputSVG" en permettant d'exporter
 * un noeud DOM "svg" dans une image qui sera ouverte dans une nouvelle fenêtre pour permettre la copie
 */
SVGBuilder.prototype.exportSVGFromDOM = function(dom) {
	// Au cas où l'on nous file le conteneur, on prend le SVG qu'on a injecté dedans
	var svg = (dom.tagName.toLowerCase() === 'svg') ? dom : dom = dom.childNodes[0];
	var xml = new XMLSerializer().serializeToString(svg);
	var url = 'data:image/svg+xml;base64,' + btoa(xml);
	var width = parseInt(svg.getAttribute('width'));
	var height = parseInt(svg.getAttribute('height'));
	var w = window.open('', 'SVG', 'location=no, menubar=no, status=no, titlebar=no, toolbar=no, width=' + (width + 50) + ', height=' + (height + 50));
	w.document.write('<img src="' + url + '" />');
};

SVGBuilder.prototype.getPoint = function(cx, cy, radius, angle) {
	return {
		x: cx + radius * Math.cos(angle),
		y: cy + radius * Math.sin(angle)
	};
};

SVGBuilder.prototype.setAttribute = function(attribute, value, start, duration) {
	this.tag('set', {
		'attributeType': 'XML',
		'attributeName': attribute,
		'to': value,
		'begin': '' + (start || 0) + 's',
		'dur': '' + (duration || 0.5) + 's',
		'fill': 'remove' // l'image initiale doit être la même que l'image finale car IE ne fait pas les animations.
	});
};

SVGBuilder.prototype.animateAttribute = function(attribute, fromValue, toValue, start, duration) {
	this.tag('animate', {
		'attributeType': 'XML',
		'attributeName': attribute,
		'from': fromValue || 0,
		'to': toValue,
		'begin': '' + (start || 0) + 's',
		'dur': '' + (duration || 0.5) + 's',
		'fill': 'remove' // l'image initiale doit être la même que l'image finale car IE ne fait pas les animations.
	});
};

SVGBuilder.prototype.animateAttributeWithKeyTimes = function(attribute, values, keyTimes, start, duration) {
	this.tag('animate', {
		'attributeType': 'XML',
		'attributeName': attribute,
		'values': values.join(' ; '),
		'keyTimes': keyTimes.join(' ; '),
		'begin': '' + (start || 0) + 's',
		'dur': '' + (duration || 0.5) + 's',
		'fill': 'remove' // l'image initiale doit être la même que l'image finale car IE ne fait pas les animations.
	});
};

SVGBuilder.prototype.animateTransform = function(type, fromValue, toValue, start, duration) {
	this.tag('animateTransform', {
		'attributeType': 'XML',
		'attributeName': 'transform',
		'type': type,
		'from': fromValue || 0,
		'to': toValue,
		'begin': '' + (start || 0) + 's',
		'dur': '' + (duration || 0.5) + 's',
		'fill': 'remove' // l'image initiale doit être la même que l'image finale car IE ne fait pas les animations.
	});
};

SVGBuilder.prototype.animateTransformWithKeyTimes = function(type, values, keyTimes, start, duration) {
	this.tag('animateTransform', {
		'attributeType': 'XML',
		'attributeName': 'transform',
		'type': type,
		'values': values.join(' ; '),
		'keyTimes': keyTimes.join(' ; '),
		'begin': '' + (start || 0) + 's',
		'dur': '' + (duration || 0.5) + 's',
		'fill': 'remove' // l'image initiale doit être la même que l'image finale car IE ne fait pas les animations.
	});
};

SVGBuilder.prototype.rect = function(x1, y1, x2, y2, color, content) {
	this.tag('rect', {
		'x': x1,
		'y': y1,
		'width': x2 - x1,
		'height': y2 - y1,
		'fill': color,
		'stroke': 'none'
	}, content);
};

SVGBuilder.prototype.rectWithWidthAnimation = function(x1, y1, x2, y2, color, start, duration) {
	this.rect(x1, y1, x2, y2, color, function() {
		this.animateAttribute('width', 0, x2 - x1, start, duration);
	}.bind(this));
};

SVGBuilder.prototype.text = function(x, y, text, anchor, color, fontSize, fontWeight, fontFamily, content) {
	this.tag('text', {
		'x': x,
		'y': y,
		'text-anchor': anchor,
		'fill': color,
		'font-size': fontSize,
		'font-weight': fontWeight,
		'font-family': fontFamily
	}, [content, text]);
};

SVGBuilder.prototype.textWithOpacityAnimation = function(x, y, text, anchor, color, fontSize, fontWeight, fontFamily, start, duration) {
	this.text(x, y, text, anchor, color, fontSize, fontWeight, fontFamily, function() {
		this.setAttribute('opacity', 0, 0, start);
		this.animateAttribute('opacity', 0, 1, start, duration);
	}.bind(this));
};

SVGBuilder.prototype.circle = function(x, y, radius, color, content) {
	this.tag('circle', {
		'cx': x,
		'cy': y,
		'r': radius,
		'fill': color
	}, content);
};

SVGBuilder.prototype.circleWithRadiusAnimation = function(x, y, radius, color, start, duration) {
	this.circle(x, y, radius, color, function() {
		this.setAttribute('r', 0, 0, start);
		this.animateAttributeWithKeyTimes('r', [0, 3 * radius, radius], [0, 0.5, 1], start, duration);
	}.bind(this));
};

SVGBuilder.prototype.arc = function(x, y, radius, color, startAngle, endAngle, content) {
	// On commence par arrondir le rayon
	radius = Math.round(radius);
	// On calcule ensuite les 2 extrémités de l'arc à dessiner
	var p1 = this.getPoint(x, y, radius, startAngle);
	var p2 = this.getPoint(x, y, radius, endAngle);
	// Le chemin dans la syntaxe SVG
	var path = 'M' + x + ',' + y; // partir du centre du cercle
	path += ' L' + p1.x + ',' + p1.y; // rejoindre le point correspondant à startAngle
	path += ' A' + radius + ',' + radius + ' 0 0,1 ' + p2.x + ',' + p2.y; // dessiner l'arc de startAngle à endAngle
	path += ' L' + x + ',' + y; // fermer en rejoignant le centre du cercle
	// Le tag SVG avec le chemin et la couleur demandée
	this.tag('path', {
		'd': path,
		'stroke': 'none',
		'fill': color
	}, content);
};

SVGBuilder.prototype.arc2 = function(x, y, outerRadius, innerRadius, color, startAngle, endAngle, content) {
	// On commence par arrondir le rayon
	outerRadius = Math.round(outerRadius);
	innerRadius = Math.round(innerRadius);
	// On calcule ensuite les 4 coins de l'arc plein à dessiner
	var p1 = this.getPoint(x, y, innerRadius, startAngle);
	var p2 = this.getPoint(x, y, outerRadius, startAngle);
	var p3 = this.getPoint(x, y, outerRadius, endAngle);
	var p4 = this.getPoint(x, y, innerRadius, endAngle);
	// Le chemin dans la syntaxe SVG
	var path = 'M' + p1.x + ',' + p1.y; // partir du point intérieur de startAngle
	path += ' L' + p2.x + ',' + p2.y; // rejoindre le point extérieur de startAngle
	path += ' A' + outerRadius + ',' + outerRadius + ' 0 0,1 ' + p3.x + ',' + p3.y; // dessiner l'arc extérieur de startAngle à endAngle
	path += ' L' + p4.x + ',' + p4.y; // rejoindre le point interne de endAngle
	path += ' A' + innerRadius + ',' + innerRadius + ' 0 0,0 ' + p1.x + ',' + p1.y; // dessiner l'arc intérieur de endAngle à startAngle
	// Le tag SVG avec le chemin et la couleur demandée
	this.tag('path', {
		'd': path,
		'stroke': 'none',
		'fill': color
	}, content);
};

SVGBuilder.prototype.triangle = function(x1, y1, x2, y2, x3, y3, color, content) {
	this.tag('polygon', {
		'points': x1 + ',' + y1 + ' ' + x2 + ',' + y2 + ' ' + x3 + ',' + y3,
		'stroke': 'transparent',
		'fill': color
	}, content);
};

SVGBuilder.prototype.triangleWithTransleAnimation = function(x1, y1, x2, y2, x3, y3, color, start, duration) {
	this.triangle(x1, y1, x2, y2, x3, y3, color, function() {
		this.animateTransform('translate', -x1, 0, start, duration);
	}.bind(this));
};

SVGBuilder.prototype.triangleWithRotateAnimation = function(x1, y1, x2, y2, x3, y3, color, start, duration, cx, cy, angle) {
	this.triangle(x1, y1, x2, y2, x3, y3, color, function() {
		this.animateTransform('rotate', (angle * 180 / Math.PI) + ' ' + cx + ' ' + cy, '0 ' + cx + ' ' + cy, start, duration);
	}.bind(this));
};

/**
 * Cette classe représente la définition et le dessin des jauges :
 * - créer la jauge :
 * 		var g = new Gauge(300, 170, pct, Gauge.types.CIRCULAR, 0, 100);
 * - paramétrer la jauge, notamment en ajoutant des intervalles et/ou le format :
 * 		g.addInterval(35, 65, 'orange');
 * 		g.valueFormat = '%VALUE% €';
 * 		g.valueDecimals = 2;
 * - préparer le générateur de SVG
 *      var builder = new SVGBuilder(g.width, g.height);
 * - dessiner la jauge
 * 		g.draw(builder, true);
 * - ajouter l'image SVG dans l'arbre DOM ou via une "img"
 *		builder.outputSVG(document.querySelector('#container'));
 *		builder.outputIMG(document.querySelector('#container'));
 */
function Gauge(width, height, value, type, minValue, maxValue, textColor) {
	this.width = width;
	this.height = height;
	this.value = value;
	this.type = type;
	this.minValue = minValue || 0;
	this.maxValue = maxValue || 100;
	this.intervals = [];
	this.decimalSeparator = '.';
	this.thousandSeparator = '';
	this.valueFormat = '%VALUE%';
	this.valueDecimals = 0;
	this.valueColor = textColor || '#6a6c6e';
	this.valueFontSize = type.defaultFontSize;
	this.valueFontWeight = '300';
	this.valueFontFamily = 'Roboto, sans-serif';
	this.valueFontDisplay = 'swap';
	this.defaultColor = '#c0bfbd';
	this.rangeDecimals = 0;
	this.rangeColor = type.defaultRangeColor(this.valueColor);
	this.rangeFontSize = 11;
	this.rangeFontWeight = '400';
	this.rangeFontFamily = 'Roboto';
	this.dimensionsElement = null;
	this.circleWidth = type.defaultCircleWidth;
}

Gauge.types = {
	/** Ce type de jauge affiche uniquement la valeur, en ajustant la taille texte et éventuellement la couleur */
	SIMPLE: {
		defaultFontSize: 66,
		defaultRangeColor: function(valueColor) { return valueColor; },
		defaultCircleWidth: 0,
		draw: function(gauge, drawing, output) {
			gauge.drawSimple(drawing, output);
		}
	},
	/** Ce type de jauge affiche la valeur entouré d'un (arc-de-)cercle', en ajustant la taille texte et éventuellement la couleur */
	CIRCLE: {
		defaultFontSize: 66,
		defaultRangeColor: function(valueColor) { return valueColor; },
		defaultCircleWidth: 15,
		draw: function(gauge, drawing, output) {
			gauge.drawCircle(drawing, output);
		}
	},
	/** Ce type de jauge affiche la valeur sous forme de compteur kilométrique, avec intervalle de couleur */
	CIRCULAR: {
		defaultFontSize: 66,
		defaultRangeColor: function(valueColor) { return valueColor; },
		defaultCircleWidth: 31,
		draw: function(gauge, drawing, output) {
			gauge.drawCircular(drawing, output);
		}
	},
	/** Ce type de jauge affiche la valeur sous forme de barre de progression horizontale, avec intervalle de couleur */
	RECTANGULAR: {
		defaultFontSize: 33,
		defaultRangeColor: function(_valueColor) { return 'white'; },
		defaultCircleWidth: 0,
		draw: function(gauge, drawing, output) {
			gauge.drawRectangular(drawing, output);
		}
	}
};

Gauge.prototype.addInterval = function(fromValue, toValue, color) {
	this.intervals.push({ fromValue: fromValue, toValue: toValue, color: color });
};

Gauge.prototype.hasValue = function() {
	return (typeof this.value === 'number') && !isNaN(this.value);
};

Gauge.prototype.getFormattedValue = function() {
	// Prise en compte du nombre de décimales souhaitées
	var text = "";
	if (typeof this.value === 'number') { 
		// text = this.value.toFixed(this.valueDecimals);
		text = BaseAPI.numberFormatFromParameters(this.value, this.valueDecimals, this.decimalSeparator, this.thousandSeparator);
	}
	// Prise en compte du format (nombre, pourcentage, monétaire) souhaité
	return this.valueFormat.replace('%VALUE%', text);
};

Gauge.prototype.draw = function(output, transparent) {
	// Remplir le fond blanc
	if (!transparent)
		output.rect(0, 0, this.width, this.height, 'white');

	// Si la valeur est inférieure au minimum, on baisse le minimum
	var minValueToDraw = Math.min(this.minValue, this.value);
	// Si la valeur est supérieure au maximum, on augmente le maximum
	var maxValueToDraw = Math.max(this.maxValue, this.value);
	// On vérifie les intervalles aussi
	var intervalsToDraw = this.intervals.map(function(interval) {
		// Si l'intervalle commence avant le début de l'échelle, on décale le début de l'intervalle
		var fromValue = Math.max(interval.fromValue, minValueToDraw);
		// Si l'intervalle termine après la fin de l'échelle, on décale la fin de l'intervalle
		var toValue = Math.min(interval.toValue, maxValueToDraw);
		return { fromValue: fromValue, toValue: toValue, color: interval.color };
	});
	// Ajuster les valeurs
	var drawing = {
		minValue: minValueToDraw,
		maxValue: maxValueToDraw,
		intervals: intervalsToDraw
	};
	// Dessiner la jauge
	this.type.draw(this, drawing, output);
	// Retirer du DOM l'élément calculant les dimensions si on en a eu besoin
	if (this.dimensionsElement != null) {
		document.body.removeChild(this.dimensionsElement);
		this.dimensionsElement = null;
	}
	// Terminer le dessin
	output.done();
};

Gauge.prototype.drawSimple = function(drawing, output) {
	if (! this.hasValue())
		return;
	// Affichage de la valeur uniquement
	var text = this.getFormattedValue();

	// - de la couleur de l'intervalle où ça tombe
	function getColor(gauge) {
		return drawing.intervals.reduce(function(current, interval) {
			if (gauge.value >= interval.fromValue && gauge.value <= interval.toValue)
				return interval.color;
			return current;
		}, gauge.valueColor);
	}

	// - de la taille qu'il faut pour ajuster à la place accordée
	function getSize(gauge) {
		// largeur max arrondie au nombre pair le plus proche
		var maxWidth = Math.floor(gauge.width / 2) * 2;
		// hauteur max arrondie au nombre pair le plus proche
		var maxHeight = Math.floor(gauge.height / 2) * 2;
		// retourner la taille de police optimale = le plus grand possible mais sans déborder
		return gauge.internalGetBestFontSize(text, maxWidth, maxHeight, gauge.valueFontWeight, gauge.valueFontFamily);
	}

	output.tag('text', {
		'x': Math.floor(this.width / 2),
		'y': this.height - 2,
		'text-anchor': 'middle',
		'fill': getColor(this),
		'font-size': getSize(this),
		'font-weight': this.valueFontWeight,
		'font-family': this.valueFontFamily,
		'font-display': this.valueFontDisplay,
	}, [function() {
		output.setAttribute('opacity', 0, 0, 0);
		output.animateAttribute('opacity', 0, 1, 0, 1);
	}, output.escapeText(text)]);
};

Gauge.prototype.drawCircle = function(drawing, output) {
	// Affichage de la valeur, au centre, de la taille idéale en fonction du cercle
	var text = this.hasValue() ?  this.getFormattedValue() : "";
	// Le centre du cercle sera à la moitié de la largeur disponible
	var centerX = Math.floor(this.width / 2);
	// Le centre du cercle sera à la moitié de la hauteur disponible
	var centerY = Math.floor(this.height / 2);
	// Le rayon sera le plus petit des deux, pour être entièrement contenu dans l'espace disponible
	var radius = Math.min(centerX, centerY);
	// Le rayon intérieur dépend du pourcentage demandé pour le cercle extérieur
	var innerRadius = Math.floor((100 - this.circleWidth) * radius / 100);
	// Le texte est limité à 80% du cercle intérieur (si présent) ou du disque (si pas de cercle)
	var textRadius = Math.floor(0.8 * (this.circleWidth === 100 ? radius : innerRadius));
	// La taille du texte sera ajustée pour passer dans un carré
	// NB: le texte peut déborder dans les coin en fonction du paramétrage et de la valeur
	var fontSize = this.internalGetBestFontSize(text, 2 * textRadius, 2 * textRadius, this.valueFontWeight, this.valueFontFamily);

	// Angle de départ de la bande de couleur = à l'est
	var fromAngle = 0;
	// Angle de fin de la bande de couleur = on pointe sur la valeur
	var toAngle = this.internalGetCircleAngle(drawing, this.value);
	// Couleur de la bande de couleur = couleur de la valeur (sauf pour les disque sans intervalle)
	var color = (this.circleWidth === 100 && drawing.intervals.length === 0) ? this.defaultColor : this.valueColor;
	// Si la valeur appartient à un intervalle, on affiche la bande de la couleur de l'intervalle
	for (var i = 0; i < drawing.intervals.length; i++) {
		var interval = drawing.intervals[i];
		if (this.value >= interval.fromValue && this.value <= interval.toValue)
			color = interval.color;
	}

	// Le cercle de la couleur de fond
	output.circle(centerX, centerY, radius, this.defaultColor);

	// L'arc de couleur pour indiquer la valeur
	// La fonction "arc" ne dessine que des arcs de moins de PI. Si on a plus à faire, on dessine en plusieurs fois
	while (fromAngle + Math.PI < toAngle) {
		// - un arc de "pi"
		output.arc(centerX, centerY, radius, color, fromAngle, fromAngle + Math.PI);
		// - on avance de "pi/2" pour que les arcs se chevauchent
		fromAngle += Math.PI / 2;
	}
	// - dernier arc restant
	output.arc(centerX, centerY, radius, color, fromAngle, toAngle);

	// L'intérieur du cercle, en blanc, sauf si on souhaite un disque
	if (this.circleWidth !== 100)
		output.circle(centerX, centerY, innerRadius, 'white');

	// La valeur, au centre
	output.tag('text', {
		'x': centerX,
		'y': Math.floor(centerY + fontSize * 0.3), // Les minuscules dont ~ 60% de fontSize en hauteur. Or, on en prend la moitié => 30%
		'text-anchor': 'middle',
		'fill': this.valueColor,
		'font-size': fontSize,
		'font-weight': this.valueFontWeight,
		'font-family': this.valueFontFamily,
		'font-display': this.valueFontDisplay,
		//'dominant-baseline': 'central' // super sous FF/Chrome pour centrer verticalement mais IE/Edge nous embêtent une fois de plus
	}, [function() {
		output.setAttribute('opacity', 0, 0, 0);
		output.animateAttribute('opacity', 0, 1, 0, 1);
	}, output.escapeText(text)]);
};

Gauge.prototype.internalGetCircleAngle = function(drawing, value) {
	return 2 * Math.PI * (value - drawing.minValue) / (drawing.maxValue - drawing.minValue);
};

/** Cette méthode retourne la taille du texte idéal pour la police donnée sous la forme d'un objet { width, height } */
Gauge.prototype.internalGetBestFontSize = function(text, maxWidth, maxHeight, fontWeight, fontFamily) {
	// Calculer les dimensions du texte s'il occupait toute la hauteur disponible
	var dimensions = this.internalGetTextDimensions(text, maxHeight + 'px', fontWeight, fontFamily);
	// En déduire le ratio pour diminuer le texte afin de s'assurer qu'il ne sorte pas de la boite
	var ratio = Math.min(1, maxWidth / dimensions.width, maxHeight / dimensions.height);
	// retourner la taille de police optimale = le plus grand possible mais sans déborder
	// NB : "Math.floor" renvoie des tailles de polices entières et on évite ainsi de déborder (https://support.solvnet.fr:9998/devels/edit/3412)
	return Math.floor(maxHeight * ratio);
};

/** Cette méthode retourne la taille du texte pour la police donnée sous la forme d'un objet { width, height } */
Gauge.prototype.internalGetTextDimensions = function(text, fontSize, fontWeight, fontFamily) {
	var e = this.dimensionsElement;
	if (e == null) {
		e = document.createElement('span');
		e.style.position = 'absolute';
		e.style.visibility = 'hidden';
		e.style.height = 'auto';
		e.style.width = 'auto';
		e.style.whiteSpace = 'nowrap';
		e.style.lineHeight = 1;
		document.body.appendChild(e);
		this.dimensionsElement = e;
	}
	e.style.fontSize = fontSize;
	e.style.fontFamily = fontFamily;
	e.style.fontWeight = fontWeight;
	e.style.fontDisplay = this.valueFontDisplay;
	e.textContent = text;
	return { width: e.clientWidth, height: e.clientHeight };
};

Gauge.prototype.drawRectangular = function(drawing, output) {
	// Espace à gauche et à droite de la barre de progression
	var hspacing = Math.max(10, this.width * 4 / 100);
	// Espace au dessus et en dessous de la barre de progression
	var vspacing = 12;
	// Hauteur de la barre
	var barHeight = 12;
	// Hauteur du triangle quand on affiche la valeur au-dessus de la barre
	var arrowHeight = 10;
	// Espace entre la barre et le bas du triangle
	var arrowSpacingBottom = 1;
	// Espace entre la barre et le bas du triangle
	var arrowSpacingTop = 4;
	// Rayon du cercle quand on affiche la valeur dans la barre
	var bubbleRadius = 10;
	// On dessinera la valeur dans la barre si on n'a pas la place à la dessiner au dessus
	var drawValueInsideBar = this.height < (2 * vspacing + barHeight + arrowSpacingBottom + arrowHeight + arrowSpacingTop + this.valueFontSize);
	// L'ordonnée du bas des rectangles
	var rectangleBottom = (this.height + 2 * vspacing + barHeight + (drawValueInsideBar ? 0 : (arrowSpacingBottom + arrowHeight + arrowSpacingTop + this.valueFontSize))) / 2;
	// L'ordonnée du haut des rectangles
	var rectangleTop = rectangleBottom - 2 * vspacing - barHeight;
	// Hauteur à laquelle écrire les graduations
	var rangeY = rectangleBottom - 2;

	// Le rectangle gris au fond de la zone rectangulaire
	output.rect(0, rectangleTop, this.width, rectangleBottom, this.defaultColor);
	// Le rectangle coloré de chaque intervalle
	drawing.intervals.forEach(function(interval) {
		var left = interval.fromValue === drawing.minValue ? 0 : this.internalGetDistance(drawing, interval.fromValue, hspacing);
		var right = interval.toValue === drawing.maxValue ? this.width : this.internalGetDistance(drawing, interval.toValue, hspacing);
		output.rect(left, rectangleTop, right, rectangleBottom, interval.color);
	}.bind(this));
	// Le rectangle un peu plus foncé pour la barre qui se remplit
	output.rect(hspacing, rectangleTop + vspacing, this.width - hspacing, rectangleBottom - vspacing, 'rgba(0,0,0,.15)');
	// Le rectangle pour la valeur
	if (this.hasValue())
		output.rectWithWidthAnimation(hspacing, rectangleTop + vspacing, this.internalGetDistance(drawing, this.value, hspacing), rectangleBottom - vspacing, this.rangeColor, 0, 0.5);

	// On remplit rangeValues avec les valeurs affichées dans la barre et qu'il faudra exclure des graduations
	var rangeValues = [drawing.minValue, drawing.maxValue, this.value];
	// Graduation min
	output.text(hspacing, rangeY, drawing.minValue.toFixed(this.rangeDecimals), 'start', this.rangeColor, this.rangeFontSize, this.rangeFontWeight, this.rangeFontFamily);
	// Graduation max
	output.text(this.width - hspacing, rangeY, drawing.maxValue.toFixed(this.rangeDecimals), 'end', this.rangeColor, this.rangeFontSize, this.rangeFontWeight, this.rangeFontFamily);
	// Graduation des intervalles
	drawing.intervals.forEach(function(interval) {
		[interval.fromValue, interval.toValue].forEach(function(value) {
			if (rangeValues.indexOf(value) === -1) {
				var t = value.toFixed(this.rangeDecimals);
				var x = this.internalGetDistance(drawing, value, hspacing);
				output.text(x - 1, rangeY, t, 'end', this.rangeColor, this.rangeFontSize, this.rangeFontWeight, this.rangeFontFamily);
				rangeValues.push(value);
			}
		}.bind(this));
	}.bind(this));

	// Affichage de la valeur, dans la bulle ou au-dessus selon les cas
	if (this.hasValue()) {
		var x = this.internalGetDistance(drawing, this.value, hspacing);
		var text = this.getFormattedValue();
		if (drawValueInsideBar) {
			output.circleWithRadiusAnimation(x, rectangleBottom - vspacing - barHeight / 2, bubbleRadius, this.rangeColor, 0.5, 0.5);
			output.textWithOpacityAnimation(x, rectangleBottom - vspacing - 2, output.escapeText(text), 'middle', this.valueColor, barHeight, this.valueFontWeight, this.valueFontFamily, 0.5, 0.5);
		} else {
			var bottom = rectangleTop - arrowSpacingBottom,
				top = bottom - arrowHeight,
				left = x - arrowHeight / 2,
				right = x + arrowHeight /2,
				anchor = 'middle',
				dimensions = this.internalGetTextDimensions(text, this.valueFontSize + 'px', this.valueFontWeight, this.valueFontFamily);
			// Dessiner le triangle qui marque la valeur
			output.triangleWithTransleAnimation(x, bottom, left, top, right, top, this.valueColor, 0, 0.5);
			// S'assurer que le texte qui affichera la valeur ne va pas déborder à droite ou à gauche
			if (x + dimensions.width / 2 > this.width) {
				x = this.width;
				anchor = 'end';
			} else if (x - dimensions.width / 2 < 0) {
				x = 0;
				anchor = 'start';
			}
			// Dessiner le texte qui affiche la valeur
			output.textWithOpacityAnimation(x, top - arrowSpacingTop, output.escapeText(text), anchor, this.valueColor, this.valueFontSize, this.valueFontWeight, this.valueFontFamily, 0.5, 0.5);
		}
	}
};

Gauge.prototype.internalGetDistance = function(drawing, value, hspacing) {
	return hspacing + (this.width - 2 * hspacing) * (value - drawing.minValue) / (drawing.maxValue - drawing.minValue);
};

Gauge.prototype.drawCircular = function(drawing, output) {
	// distance du centre jusqu'à l'extérieur de l'arche
	var outerRadius = Math.min(this.width / 2, this.height);
	// distance du centre jusqu'à l'intérieur de l'arche
	var innerRadius = (100 - this.circleWidth) * outerRadius / 100;
	// centre de la gauge
	var center = this.internalGetCenter();
	// angle correspondant à la valeur pointée
	var angle = this.hasValue() ? this.internalGetAngle(drawing, this.value) : 0;
	// espace entre l'arche et le triangle
	var arrowSpacing = 4;
	// longueur du triangle
	var arrowSize = innerRadius / 4;
	// taille de la police pour afficher la valeur
	var usedValueFontSize = Math.min(2 * innerRadius / 3, this.valueFontSize);
	// les points de la pointe de la flêche
	var arrowP1, arrowP2, arrowP3;

	// Remplir un arc gris pour servir d'arche par défaut
	output.arc2(center.x, center.y, outerRadius, innerRadius, this.defaultColor, -Math.PI, 0);
	// Remplir les arcs de couleurs pour chaque intervalle
	drawing.intervals.forEach(function(interval) {
		var fromAngle = this.internalGetAngle(drawing, interval.fromValue);
		var toAngle = this.internalGetAngle(drawing, interval.toValue);
		output.arc2(center.x, center.y, outerRadius, innerRadius, interval.color, -fromAngle, -toAngle);
	}.bind(this));

	if (this.hasValue()) {
		// le point visé par la flêche
		arrowP1 = this.internalGetPoint(center.x, center.y, innerRadius - arrowSpacing, angle);
		// le point de la flêche en retrait + loin
		arrowP2 = this.internalGetPoint(center.x, center.y, innerRadius - arrowSpacing - arrowSize, angle + 0.5 / (2 * Math.PI));
		// le point de la flêche en retrait -loin
		arrowP3 = this.internalGetPoint(center.x, center.y, innerRadius - arrowSpacing - arrowSize, angle - 0.5 / (2 * Math.PI));

		// Ecrire la valeur au centre
		output.textWithOpacityAnimation(center.x, center.y - 1, output.escapeText(this.getFormattedValue()), 'middle', this.valueColor, usedValueFontSize, this.valueFontWeight, this.valueFontFamily, 0.5, 0.5);
		// Pointer la valeur avec une flêche
		output.triangleWithRotateAnimation(arrowP1.x, arrowP1.y, arrowP2.x, arrowP2.y, arrowP3.x, arrowP3.y, this.valueColor, 0, 0.5, center.x, center.y, angle - Math.PI, 0);
	}

	// Valeurs des graduations
	var rangeValues = [this.value, drawing.minValue, drawing.maxValue];
	drawing.intervals.forEach(function(interval) {
		if (rangeValues.indexOf(interval.fromValue) === -1)
			rangeValues.push(interval.fromValue);
		if (rangeValues.indexOf(interval.toValue) === -1)
			rangeValues.push(interval.toValue);
	}.bind(this));

	// Ne pas afficher la valeur elle-même puisqu'elle apparait déjà au centre
	rangeValues.shift();

	// Ecrire les graduations (min + max + from/to de chaque intervalle)
	rangeValues.forEach(function(value) {
		var p = this.internalGetRangePoint(drawing, value, center, outerRadius, innerRadius);
		output.text(p.x, p.y, value.toFixed(this.rangeDecimals), p.anchor, this.rangeColor, this.rangeFontSize, this.rangeFontWeight, this.rangeFontFamily);
	}.bind(this));
};

Gauge.prototype.internalGetAngle = function(drawing, value) {
	return Math.PI * (drawing.maxValue - value) / (drawing.maxValue - drawing.minValue);
};

Gauge.prototype.internalGetCenter = function() {
	var x = Math.floor(this.width / 2);
	var y = this.height;
	if (x < y)
		y -= (this.height - x) / 2;
	return { x: x, y: y };
};

Gauge.prototype.internalGetPoint = function(cx, cy, radius, angle) {
	return {
		x: cx + Math.round(radius * Math.cos(angle)),
		y: cy - Math.round(radius * Math.sin(angle))
	};
};

Gauge.prototype.internalGetRangePoint = function(drawing, value, center, outerRadius, innerRadius) {
	// La valeur minimale est forçément affichée à l'intérieur, en commençant à 3px du bord intérieur de l'arc
	if (value === drawing.minValue) {
		return {
			x: center.x - innerRadius + 3,
			y: center.y,
			anchor: 'start'
		};
	}
	// La valeur maximale est forçément affichée à l'intérieur, en terminant à 3px du bord intérieur de l'arc
	if (value === drawing.maxValue) {
		return {
			x: center.x + innerRadius - 3,
			y: center.y,
			anchor: 'end'
		};
	}
	// Pour les autres limites d'intervalles, on essaie de l'afficher à l'extérieur. Si ça dépasse, on l'affiche à l'intérieur
	var text = value.toFixed(this.rangeDecimals);
	var dimensions = this.internalGetTextDimensions(text, this.rangeFontSize + 'px', this.rangeFontWeight, this.rangeFontFamily);
	var angle = this.internalGetAngle(drawing, value);

	// On essaie d'abord d'afficher la graduation à l'extérieur
	var point = this.internalGetPoint(center.x, center.y, outerRadius, angle);
	// On pointe sur le centre du texte
	point.anchor = 'middle';
	// le décalage en "x" part de -(6+d.w)/2 (à min) puis monte à 0 (au milieu) puis monte encore jusqu'à (6+d.w)/2 (à max) => dépend de cos(angle)
	point.x += Math.round((6 + dimensions.width) * Math.cos(angle) / 2);
	// le décalage en "y" part de 0 (à min) puis descend jusqu'à "-3" (au milieu) puis remonte à 0 (à max) => dépend de -sin(angle)
	point.y += Math.round(3 * - Math.sin(angle));

	// Si ça dépasse au dessus ou à gauche ou à droite, on affichera la valeur à l'intérieur
	if (point.y - dimensions.height < 0
			|| point.x - dimensions.width / 2 < 0
			|| point.x + dimensions.width / 2 > this.width) {
		// Affichage de la graduation à l'intérieur
		point = this.internalGetPoint(center.x, center.y, innerRadius, angle);
		// On pointe sur le centre du texte
		point.anchor = 'middle';
		// le décalage en "x" part de (6+d.w)/2 (à min) puis descend à 0 (au milieu) puis descend encore jusqu'à -(6+d.w)/2 (à max) => dépend de -cos(angle)
		point.x += Math.round(- (6 + dimensions.width) * Math.cos(angle) / 2);
		// le décalage en "y" part de 0 (à min) puis monte jusqu'à "dimensions.height + 3" (au milieu) puis redescend à 0 (à max) => dépend de sin(angle)
		point.y += Math.round((dimensions.height + 3) * Math.sin(angle));
	}
	return point;
};

/**
 * Ce constructeur instancie un diagramme vide, à remplir ensuite avec "addMeasure" puis "addCategory"
 * pour enfin générer un diagramme en appelant l'une des méthode "build___Chart(div)".
 *
 * Exemple d'utilisation :
 *
 * <code>
 * var callback = function(chart, measureIndex, categoryIndex) {
 *   var measure = chart.measures[measureIndex];
 *   var category = chart.categories[categoryIndex];
 *   console.log('Clic sur la mesure ' + measure.caption + ' de la catégorie ' + category.caption);
 * };
 *
 * var diagramme = new Diagramme();
 * diagramme.title = 'Titre du diagramme';
 * diagramme.showLabels = true;
 * diagramme.showLabelsAsPercentage = true;
 * diagramme.showLegend = true;.
 * diagramme.hideLevelsLabel = false;
 * diagramme.showExport = true;
 * diagramme.showLastMeasureWithLine = true;
 * diagramme.onclick = callback;
 * diagramme.categoriesTitle = 'Enseignes';
 * diagramme.format = '%VALUE% €';
 * diagramme.addMeasure('Barre 1', 0, '', 'ce qu\'on veut');
 * diagramme.addMeasure('Barre 2', 1, '', ['vraiment ce qu\'on veut']);
 * diagramme.addMeasure('Ligne', 2, null);
 * diagramme.addCategorie('Enseigne 1', [1,2,3], false, null);
 * diagramme.addCategorie('Enseigne 2', [3,2,1], false, null);
 * diagramme.addCategorie('TOTAUX', [4,4,4], true, null);
 *
 * var chart = diagramme.buildVerticalBarChart(container);
 * // "chart" est un diagramme au sens "Highchart", avec les API associées comme "chart.reflow()".
 * </code>
 *
 * @constructor
 * @member {String} title - le titre du diagramme
 * @mmember{Array} measures - la liste des mesures ajoutées via addMeasure
 * @mmember{Array} categories - la liste des categories ajoutées via addCategory
 * @member {String} categoriesTitle - le titre de l'axe des catégories, si dispo selon le type de diagramme
 * @member {Boolean} showLabels - indique si on affiche les étiquettes (sauf pour les diagramme "Barres circulaires", "Rose" et "Radar")
 * @member {Boolean} showLabelsAsPercentage - indique si les étiquettes affichent en pourcentage plutôt qu'en valeur (non applicable aux "Barres circulaires", "Rose" et "Radar")
 * @member {Boolean} showLegend - indique si on affiche la légende (sauf pour les diagramme "Pyramide", "Bulles" et "Points")
 * @member {Boolean} hideLevelsLabel - indique si on masque le libellé des niveaux.
 * @member {Boolean} showExport - indique si on affiche le menu d'export en PNG/JPEG/...
 * @member {Boolean} showLastMeasureWithLine - indique pour les diagramme "barres" et "surfaces" si la dernière mesure doit s'afficher en ligne
 * @member {Boolean} showTextShadow - par défaut désactivée, l'option permet de réactiver les ombres sous le texte gérer par HighCharts pour la lisibilité
 * @member {Function(diagramme, measureIndex, categoryIndex)} onclick - fonction de callback à appeler quand on clique sur le diagramme, en précisant la mesure et la catégorie cliquée.
 * @member {Array[CSSColor]} colors - le tableau de couleurs pour les séries. Si le tableau est trop petit, HighChart bouclera
 * @member {String} format - le format d'affichage (par défaut '%VALUE%' mais d'autres valeurs comme 'EUR %VALUE%' ou '%VALUE% %' sont possibles)
 */
function Diagramme() {
	this.title = '';
	this.measures = [];
	this.categories = [];
	this.categoriesTitle = '';
	this.showLabels = false;
	this.showLabelsAsPercentage = false;
	this.showLegend = false;
	this.hideLevelsLabel = false;
	this.showExport = false;
	this.showLastMeasureWithLine = false;
	this.showTextShadow = false;
	this.onclick = null;
	this.colors = Highcharts.getOptions().colors;
	this.format = '%VALUE%';
}

/**
 * Cette fonction alimente un diagramme avec des aléatoires pour test
 */
Diagramme.prototype.test = function(measureCount, categoryCount, withTotals) {
	// Titre du diagramme, affiché en haut
	this.title = 'Titre du diagramme';
	// Agrégateurs, au hasard, quand on limite le nombre de catégories (si on affiche les totaux, on autorise "sum". Sinon, ça déforme)
	var aggregators = [undefined, 'avg', 'min', 'max', 'repeated'];
	if (withTotals)
		aggregators.push('sum');
	// Ajout des mesures
	for (var mi = 1; mi <= measureCount; mi++) {
		this.addMeasure('Mesure ' + mi, Math.floor(3 * Math.random()), null, aggregators[mi % aggregators.length]);
	}
	function randomValues() {
		var result = [];
		result.push(10 * Math.random()); // 1 mesure avec pleins de chiffres après la virgule
		for (var vi = 2; vi <= measureCount; vi++) {
			result.push(Math.floor(10 * Math.random()));
		}
		return result;
	}
	if (categoryCount > 0) {
		this.categoriesTitle = 'Niveau';
		for (var ci = 1; ci <= categoryCount; ci++) {
			this.addCategory('Catégorie ' + ci, randomValues(), false, null);
		}
	}
	if (withTotals || categoryCount === 0)
		this.addCategory('TOTAUX', randomValues(), true, null);
};

/**
 * Cette méthode ajoute une mesure au diagramme
 *
 * @param {String} caption - l'intitulé de la mesure
 * @param {Number} decimals - le nombre de décimales utilisée pour afficher les valeurs de cette mesure
 * @param {Any} data - données personnalisée, conserver avec la mesure pour la retrouver plus tard (dans "onclick" par exemple)
 * @param {String} aggregator - l'agrégateur ('avg' par défaut, 'min'/'max'/'repeated'/'sum' possible) pour la catégorie "Autres" quand on limite le nombre de catégories
 */
Diagramme.prototype.addMeasure = function(caption, decimals, data, aggregator) {
	this.measures.push({ caption: caption, decimals: decimals, data: data, aggregator: aggregator });
};

/**
 * Cette méthode ajoute une categorie au diagramme
 *
 * @param {String} caption - l'intitulé de la categorie
 * @param {Array[Number]} values - le tableau des valeurs de chaque mesure pour cette catégorie
 * @param {Boolean} isTotals - indique si la catégorie représente les totaux (par exemple, dans les camemberts, la part sera "séparée")
 * @param {Any} data - données personnalisée, conserver avec la catégorie pour la retrouver plus tard (dans "onclick" par exemple)
 */
Diagramme.prototype.addCategory = function(caption, values, isTotals, data) {
	this.categories.push({ caption: caption, values: values, isTotals: isTotals, data: data, toString: function() { return caption; } });
};

/**
 * Cette méthode limite le nombre de catégories affichées, par exemple à 10 éléments :
 * - les diagrammes avec 1 à 10 catégories ne changent pas
 * - sinon, seules les 9 premières catégories sont affichées normalement
 * - les catégories suivantes sont cumulées dans une 10ème catégories unique "Autres"
 *
 * Seule exception : si les totaux sont demandés, on les affichera dans tous les cas à part (mais ça fera une catégorie de moins)
 *
 * @param {Number} limit - le nombre d'élément max à afficher normalement (les autres seront fusionnés)
 * @param {String} caption - le nom de la catégorie ("Autres (%COUNT%)" par exemple)
 */
Diagramme.prototype.limitCategories = function(limit, caption) {
	// S'il y a moins de catégories, on n'a rien à faire
	if (this.categories.length <= limit)
		return;
	// On récupère les catégories
	var oldCategories = this.categories.filter(function(c) { return ! c.isTotals; });
	// On récupère les totaux éventuels
	var totalCategory = this.categories.find(function(c) { return c.isTotals; });
	// On déduit le début des catégories à fusionner
	var firstIndex = limit - (totalCategory ? 2 : 1);
	// On déduit aussi la fin des catégories à fusionner
	var lastIndex = oldCategories.length;
	// On crée une catégorie "Autres"
	var otherCategory = { caption: caption.replace('%COUNT%', lastIndex - firstIndex), values: [], isTotals: true, toString: function() { return this.caption; } };

	// On cumule ensuite les mesures
	this.measures.forEach(function(m, mi) {
		var a = BaseAPI.aggregate(false, null);
		for (var i = firstIndex; i < lastIndex; i++) {
			a.add(oldCategories[i].values[mi]);
		}
		switch (m.aggregator) {
		case 'min':
			otherCategory.values.push(a.getMin());
			break;
		case 'max':
			otherCategory.values.push(a.getMax());
			break;
		case 'sum':
			otherCategory.values.push(a.getSum());
			break;
		case 'repeated':
			otherCategory.values.push(a.getRepeated());
			break;
		default:
		case 'avg':
			otherCategory.values.push(a.getAvg());
			break;
		}
	});

	// On prépare la liste finale
	this.categories = oldCategories.filter(function(_category, index) { return index < firstIndex; });
	this.categories.push(otherCategory);
	if (totalCategory)
		this.categories.push(totalCategory);
};

/** http://www.highcharts.com/demo/pyramid */
Diagramme.prototype.buildPyramidChart = function(div) {
	var self = this;
	// Récupération des entrées (vide par défaut)
	var entries;
	// Si on n'a qu'une catégorie, on fait une pyramide avec une entrée par mesure
	if (this.categories.length === 1) {
		entries = this.measures.map(function(m, i) {
			return [m.caption, self.categories[0].values[i], i, 0];
		});
	} else {
		// Sinon, on fait une pyramide avec une entrée par catégorie mais une seule mesure
		entries = this.categories.map(function(c, i) {
			return [c.caption, c.values[0], 0, i];
		});
	}
	// Afficher une pyramide (du plus petit au plus grand) ou un entonnoir (du plus grand au plus petit)
	var pyramid = entries[0][1] < entries[entries.length - 1][1];
	if (pyramid)
		entries.reverse();
	// Format d'affichage
	var valuesFormat = this.internalGetFormat('point.y', 'max');
	var labelsFormat = this.showLabelsAsPercentage ? this.internalGetPercentFormat(1) : valuesFormat;
	var marginRight = (this.showLabels ? 100/*pour décaller sur la gauche*/ : 0);
	var marginBottom = (this.showLabels ? 30/*pour que la valeur des totaux soit visible, même tout en bas*/ : undefined);
	// Options du diagramme
	var options = this.internalBuildChartOptions(pyramid ? 'pyramid' : 'funnel', {
		chart: { marginRight: marginRight, marginBottom: marginBottom },
		title: { x: -marginRight / 2 },
		tooltip: { pointFormat: '(' + valuesFormat + ')' },
		legend: { enabled: false },
		plotOptions: {
			series: {
				neckWidth: 0,
				neckHeight: 0,
				dataLabels: {
					enabled: this.showLabels,
					format: '<b>{point.name}</b><br />(' + labelsFormat + ')',
					color: '#444',
					style: { fontWeight: 'normal' },
					softConnector: false
				}
			}
		},
		series: [{ name: 'Values', data: entries }]
	});
	// Détecter les clics pour prévenir la page, si demandé
	if (this.onclick) {
		options.plotOptions.series.cursor = 'pointer';
		options.plotOptions.series.point = { events: { click: function(event) {
			// Appel du listener
			var entry = entries[event.point.x];
			self.onclick(self, entry[2], entry[3]);
			// Si les étiquettes sont affichées, on marque la sélection en gras/souligné
			if (self.showLabels) {
				// Rechercher les "text" correspondant aux étiquettes
				var texts = event.point.dataLabel.element.parentNode.querySelectorAll('.highcharts-label > text');
				// Retirer le gras/souligné sur l'éventuel "text" précédent
				var wasSelected = texts[event.point.x].style.fontWeight === 'bold'
					&& texts[event.point.x].style.textDecoration === 'underline';
				for (var i = 0; i < texts.length; i++) {
					texts[i].style.fontWeight = 'normal';
					texts[i].style.textDecoration = 'none';
				}
				// Ajouter le gras/souligné au "text" correspondant à l'étiquette cliquée si l'élément n'était pas déjà sélectionné
				// Sinon la boucle précédente s'est chargé de lui remettre le style normal
				if (!wasSelected) {
					texts[event.point.x].style.fontWeight = 'bold';
					texts[event.point.x].style.textDecoration = 'underline';
				}
			}
		}}};
	}
	return Highcharts.chart(div, options);
};

/** http://www.highcharts.com/demo/pie-basic */
Diagramme.prototype.buildPieChart = function(div) {
	return this.internalBuildPieDonutArcChart(div, false, false);
};

/** http://www.highcharts.com/demo/pie-donut */
Diagramme.prototype.buildDonutChart = function(div) {
	return this.internalBuildPieDonutArcChart(div, true, false);
};

/** http://www.highcharts.com/demo/pie-semi-circle */
Diagramme.prototype.buildArcChart = function(div) {
	return this.internalBuildPieDonutArcChart(div, true, true);
};

/** http://www.highcharts.com/demo/gauge-activity */
Diagramme.prototype.buildRadialBarChart = function(div) {
	var self = this;
	// Récupération des entrées (vide par défaut)
	var entries = [], max = Number.NEGATIVE_INFINITY;
	// Si on n'a qu'une catégorie, on fait une suite avec les mesures
	if (this.categories.length === 1) {
		entries = this.measures.map(function(m, i) {
			var v = self.categories[0].values[i];
			max = Math.max(max, v);
			return { caption: m.caption, value: v, measureIndex: i, categoryIndex: 0 };
		});
	} else {
		// Sinon, on fait une suite avec une entrée par catégorie mais une seule mesure
		entries = this.categories.map(function(c, i) {
			var v = c.values[0];
			max = Math.max(max, v);
			return { caption: c.caption, value: v, measureIndex: 0, categoryIndex: i };
		});
	}
	var legendOffset = 100;
	var innerRadius = 35;
	var outerRadius = 112;
	var size = Math.floor((outerRadius - innerRadius) / entries.length);
	var colors = this.colors;

	// Trier les entrées pour que les plus grandes valeurs soient à l'intérieur
	// Les plus petites, à l'extérieur, sont plus faciles à cliquer que si elles étaient à l'intérieur
	entries.sort(function(e1, e2) { return e1.value - e2.value; });

	// Options du diagramme
	var options = this.internalBuildChartOptions('solidgauge', {
		chart: { marginRight: (this.showLegend ? legendOffset : 0) },
		title: { x: (this.showLegend ? -legendOffset/2 : 0) },
		tooltip: { followPointer: true },
		pane: {
			startAngle: 0,
			endAngle: 360,
			background: entries.map(function(_entry, index) {
				return {
					outerRadius: (outerRadius - size * index) + '%',
					innerRadius: (outerRadius - size * (index + 1) + 1) + '%',
					// backgroundColor: Highcharts.Color(colors[index]).setOpacity(0.15).get(),
					backgroundColor: 'rgba(208,208,208,0.3)',
					borderWidth: 0
				};
			})
		},
		yAxis: { max: max * 1.05, lineWidth: 0, tickPositions: [] },
		plotOptions: {
			solidgauge: {
				borderWidth: '0',
				dataLabels: { enabled: false /*pas de "label" pour ce graphe car les étiquettes s'empilent en plus d'être plutôt moches */ },
				stickyTracking: false,
			}
		},
		series: entries.map(function(entry, index) {
			return {
				name: entry.caption,
				borderColor: colors[index % colors.length],
				tooltip: { valueDecimals: self.measures[entry.measureIndex].decimals },
				allowPointSelect: true,
				data: [{
					color: colors[index % colors.length],
					radius: (outerRadius - size * index) + '%',
					innerRadius: (outerRadius - size * (index + 1) + 1) + '%',
					y: entry.value
				}]
			};
		})
	});
	// Détecter les clics pour prévenir la page, si demandé
	if (this.onclick) {
		options.plotOptions.solidgauge.cursor = 'pointer';
		options.plotOptions.solidgauge.events = {
			click: function(_event) {
				var entry = entries[this.index];
				self.onclick(self, entry.measureIndex, entry.categoryIndex);
			}
		};
	}
	var loadedCallback;
	if (this.showLegend) {
		loadedCallback = function(chart) {
			var group = chart.renderer.g().add();
			chart.series.forEach(function(serie, serieIndex) {
				var value = serie.data[0].y;
				if (value === null || value === undefined)
					return;
				var color = serie.data[0].color;
				var decimals = self.measures[entries[serieIndex].measureIndex].decimals;
				var html = '<b>' + serie.name + '</b> (' + value.toFixed(decimals) + ')';
				var x = chart.plotLeft + chart.plotWidth + legendOffset - 10;
				var y = chart.plotTop + serieIndex * 18 /*(size * chart.plotHeight / 200)*/;
				chart.renderer.text(html, x, y, false)
					.attr({ zIndex: 5, 'text-anchor': 'end', 'fill': color, 'font-size': '10px' })
					.addClass('category')
					.add(group);
			});
		};
	}
	return Highcharts.chart(div, options, loadedCallback);
};

/** http://www.highcharts.com/demo/polar-wind-rose */
Diagramme.prototype.buildRoseChart = function(div) {
	var self = this;
	var options = this.internalBuildChartOptions('column', {
		chart: { polar: true },
		xAxis: { categories: this.categories, tickmarkPlacement: 'on' },
		yAxis: { endOnTick: false, showLastLabel: true, title: { text: '' }, reversedStacks: false },
		plotOptions: { series: { stacking: 'normal', shadow: false, groupPadding: 0, pointPlacement: 'on' } },
		series: this.measures.map(function(measure, index) {
			var serie = {
				name: measure.caption,
				data: self.categories.map(function(c) { return c.values[index]; }),
				tooltip: { valueDecimals: measure.decimals }
			};
			// Si demandé, forcer l'affichage de la dernière mesure en "ligne"
			if (self.showLastMeasureWithLine && (index === self.measures.length - 1)) {
				serie.type = 'line';
				serie.dataLabels = { enabled: true, format: self.internalGetFormat('y', Math.min(1, measure.decimals)) };
			}
			return serie;
		})
	});
	this.internalAddSeriesClick(div, options);
	this.internalAddCategoriesClick(div, options);
	return Highcharts.chart(div, options);
};

/** http://www.highcharts.com/demo/polar-spider */
Diagramme.prototype.buildRadarChart = function(div) {
	var self = this;
	var options = this.internalBuildChartOptions('area', {
		chart: { polar: true },
		xAxis: { categories: this.categories, tickmarkPlacement: 'on', lineWidth: 0 },
		yAxis: { gridLineInterpolation: 'polygon', title: { text: '' } },
		plotOptions: { series: { pointPlacement: 'on' } },
		series: this.measures.map(function(measure, index) {
			var serie = {
				name: measure.caption,
				data: self.categories.map(function(c) { return c.values[index]; }),
				tooltip: { valueDecimals: measure.decimals }
			};
			// Si demandé, forcer l'affichage de la dernière mesure en "ligne"
			if (self.showLastMeasureWithLine && (index === self.measures.length - 1)) {
				serie.type = 'line';
				serie.dataLabels = { enabled: true, format: self.internalGetFormat('y', Math.min(1, measure.decimals)) };
			}
			return serie;
		})
	});
	this.internalAddSeriesClick(div, options);
	this.internalAddCategoriesClick(div, options);
	return Highcharts.chart(div, options);
};

/** http://www.highcharts.com/demo/column-negative */
Diagramme.prototype.buildVerticalBarChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'column', false, false);
};

/** http://www.highcharts.com/demo/column-stacked */
Diagramme.prototype.buildVerticalStackedBarChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'column', true, false);
};

/** http://www.highcharts.com/demo/line-basic */
Diagramme.prototype.buildVerticalLineChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'line', false, true);
};

/** http://www.highcharts.com/demo/line-basic */
Diagramme.prototype.buildVerticalStackedLineChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'line', true, true);
};

/** http://www.highcharts.com/demo/spline-inverted */
Diagramme.prototype.buildVerticalSplineChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'spline', false, true);
};

/** http://www.highcharts.com/demo/area-basic */
Diagramme.prototype.buildVerticalAreaChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'area', false, true);
};

/** http://www.highcharts.com/demo/area-stacked */
Diagramme.prototype.buildVerticalStackedAreaChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'area', true, true);
};

/** http://www.highcharts.com/demo/column-negative */
Diagramme.prototype.buildHorizontalBarChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'bar', false, false);
};

/** http://www.highcharts.com/demo/column-stacked */
Diagramme.prototype.buildHorizontalStackedBarChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'bar', true, false);
};

/** http://www.highcharts.com/demo/line-basic */
Diagramme.prototype.buildHorizontalLineChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'line', false, false);
};

/** http://www.highcharts.com/demo/line-basic */
Diagramme.prototype.buildHorizontalStackedLineChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'line', true, false);
};

/** http://www.highcharts.com/demo/spline-symbols */
Diagramme.prototype.buildHorizontalSplineChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'spline', false, false);
};

/** http://www.highcharts.com/demo/area-basic */
Diagramme.prototype.buildHorizontalAreaChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'area', false, false);
};

/** http://www.highcharts.com/demo/area-stacked */
Diagramme.prototype.buildHorizontalStackedAreaChart = function(div) {
	return this.internalBuildBarColumnAreaLineSplineChart(div, 'area', true, false);
};

/** http://www.highcharts.com/demo/bubble */
Diagramme.prototype.buildBubbleChart = function(div) {
	return this.internalBuildBubbleScatterChart(div, 'bubble', true);
};

/** http://www.highcharts.com/demo/scatter */
Diagramme.prototype.buildScatterChart = function(div) {
	return this.internalBuildBubbleScatterChart(div, 'scatter', false);
};

/**
 * Cette méthode fusionne dans "target" les propriétés définies dans "properties" et renvoie "target"
 *
 * @param {Object} target - l'objet à compléter
 * @param {Object} properties - l'objet contenant les propriétés à ajouter dans "target"
 * @return "target", complété avec les propriétés de "properties"
 */
Diagramme.prototype.internalMergeObjects = function(target, properties) {
	for (var p in properties) {
		var value = target[p];
		var isObject = (typeof value === 'object') && (value != null) && !(value instanceof Array) && !(value instanceof Date);
		if (!isObject)
			target[p] = properties[p];
		else
			this.internalMergeObjects(target[p], properties[p]);
	}
	return target;
};

/**
 * Cette méthode crée les options d'un diagramme Highcharts en commençant par les options
 * communes (type, titre, credits, export, tooltip) puis en personnalisant avec "customOptions".
 *
 * @param {String} type - le type de diagramme Highchart (pie, bar, column, bubble, ...)
 * @param {Object} customOptions - les options spécifiques au type de diagramme
 * @return un objet contenant les options pour Highchart de ce type de diagramme, personnalisé par "customOptions"
 */
Diagramme.prototype.internalBuildChartOptions = function(type, customOptions) {
	return this.internalMergeObjects({
		chart: { type: type },
		title: { text: this.title },
		credits: { enabled: false },
		colors: this.colors,
		legend: { enabled: this.showLegend },
		exporting: {
			enabled: this.showExport,
			fallbackToExportServer: false,
			libURL: '../../libs/highcharts/lib',
			filename: 'image',
			buttons: { contextButton: this.internalBuildChartMenuButton() }
		},
		plotOptions: this.showTextShadow ? {} : { series: { dataLabels: { style: { textOutline: false, color: '#000'/*, 'text-shadow': '1px 1px 1px #fff'*/ } } } },
		tooltip: {
			pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>' + (this.format ? this.format.replace('%VALUE%', '{point.y}') : '{point.y}') + '</b><br/>',
			shared: true,
			useHTML: true,
			borderColor: '#444',
			backgroundColor: 'rgba(68, 68, 68, 0.8)',
			padding: 4,
			style: { color: 'white' }
		}
	}, customOptions);
};

/**
 * Cette méthode crée le paramétrage du bouton affichant le menu d'export.
 * - les boutons existants peuvent être référencés
 *     - par leur nom (printChart, separator, downloadPNG, downloadJPEG, downloadPDF et downloadSVG)
 *     - sous forme d'objets { textKey: '...', onclick: function() { this.exportChartLocal(...); } }
 * - d'autres boutons peuvent être ajoutés sous forme d'obtjets { text: 'Blablabla', onclick: function() { ... } }
 *
 * NB: cf https://support.solvnet.fr:9998/devels/edit/2668
 * - l'export PDF débloque sous tous les navigateurs, voire plante sous IE11 et Edge. On retire donc l'export PDF dans tous les cas
 * - l'export PNG et JPEG débloque sous IE11 mais fonctionne ailleurs. On les retire donc des exports uniquement sous IE
 * NB: cf https://support.solvnet.fr:9998/devels/edit/2853
 * - la taille des images dans l'export de base est mal gérée (largeur fixe, hauteur dynamique, échelle double.
 * - on surcharge donc les boutons de bases pour préciser les tailles nous-mêmes
 *
 * @return un objet pouvant être utilisé pour l'option "exporting.buttons.contextButton" de HighChart
 */
Diagramme.prototype.internalBuildChartMenuButton = function() {
	var isIE = navigator.userAgent.indexOf('MSIE') >= 0 || navigator.userAgent.indexOf('Trident/') >= 0;
	var download = function(textkey, type) {
		return {
			textKey: textkey,
			onclick: function() {
				this.exportChartLocal({
					sourceWidth: this.renderTo.clientWidth,
					sourceHeight: this.renderTo.clientHeight,
					scale: 1,
					type: type
				});
			}
		};
	};
	var exportButtons = [];
	exportButtons.push({
		textKey: 'printChart',
		onclick: function() {
			this.options.exporting.printMaxWidth = this.renderTo.clientWidth;
			this.print();
		}
	});
	if (!isIE) {
		exportButtons.push(download('downloadPNG', undefined));
		exportButtons.push(download('downloadJPEG', 'image/jpeg'));
	}
	exportButtons.push(download('downloadSVG', 'image/svg+xml'));
	return { symbol: 'menu', menuItems: exportButtons };
};

/**
 * Cette méthode construit une chaine de formattage pour highchart pour afficher une expression (par exemple "point.y")
 * avec un certain nombre de décimales ("decimals") pour le format général demandé ("this.format").
 *
 * @param {String} expression - la valeur à formatter ("point.y", ...)
 * @param {Number|'min'|'max'} decimals - le nombre de décimales (0, 1, 2, ...) ou le 'min'/'max' de décimales des mesures affichées
 * return une chaine de formattage, par exemple "{point.y:,.2f} €"
 */
Diagramme.prototype.internalGetFormat = function(expression, decimals) {
	// Récupération du nombre de décimales (par défaut, le max de toutes)
	if (typeof decimals === 'string')
		decimals = Math[decimals].apply(Math, this.measures.map(function(m) { return m.decimals; }));
	// Création d'un format selon la syntaxe de Highchart
	var f = '{' + expression + ':,.' + decimals + 'f}';
	// Prise en compte des formats demandés (nombres, pourcentage ou monétaire principalement)
	return this.format ? this.format.replace('%VALUE%', f) : f;
};

/**
 * Cette méthode construit une chaine de formattage pour highchart pour afficher les valeurs en pourcentage, quand c'est
 * demandé, avec un certain nombre de décimales ("decimals"), indépendament du format général demandé ("this.format").
 *
 * NB1: le nombre de décimal du pourcentage n'est pas nécessairement celui des mesures (ex: montant en centime mais pourcentage arrondis)
 * NB2: le format nombre, monétaire ou pourcentage (this.format) ne compte pas non plus (on veut éviter "4.19 €%", cf bug 2901)
 *
 * @param {Number} decimals - le nombre de décimales (0, 1, 2, ...) pour l'affichage des pourcentages
 * return une chaine de formattage, par exemple "{point.percentage:,.1f}%"
 */
Diagramme.prototype.internalGetPercentFormat = function(decimals) {
	return '{point.percentage:,.' + decimals + 'f}%';
};

/**
 * Cette méthode crée un diagramme "Camembert" ou ses variantes "Donut" (trou au milieu) et "Arc" (demi-cercle).
 *
 * @param {HTMLElement} div - le div dans lequel créer le diagramme
 * @param {boolean} donut - indique si c'est un donut (si on fait un trou au milieu)
 * @param {boolean} arc - indique si c'est un arc (demi-cercle au lieu de cercle)
 */
Diagramme.prototype.internalBuildPieDonutArcChart = function(div, donut, arc) {
	// Format d'affichage
	var valuesFormat = this.internalGetFormat('point.y', this.measures[0].decimals);
	var percentageFormat = this.internalGetPercentFormat(1);
	// Options du diagramme
	var options = this.internalBuildChartOptions('pie', {
		tooltip: { pointFormat: '<b>{series.name}</b> : ' + valuesFormat + ' (' + percentageFormat + ')' },
		plotOptions: { pie: {
			showInLegend: true,
			// géré par nous dans le "click" avec event.point.select(true, false);
			// allowPointSelect: true,
			cursor: 'pointer',
			center: ['50%', arc ? '75%' : '50%'],
			startAngle: arc ? -90 : 0,
			endAngle: arc ? 90 : null,
			dataLabels: {
				enabled: this.showLabels,
				format: '<b>{point.name}</b> (' + (this.showLabelsAsPercentage ? percentageFormat : valuesFormat) + ')',
				color: '#444',
				style: { fontWeight: 'normal' }
			}
		}},
		series: [{
			name: this.measures[0].caption,
			innerSize: donut ? '75%' : 0,
			data: this.categories.map(function(c) {
				return { name: c.caption, y: c.values[0], sliced: c.isTotals, selected: c.isTotals };
			})
		}]
	});
	// Détecter les clics pour prévenir la page, si demandé
	if (this.onclick) {
		var self = this;
		options.plotOptions.pie.point = { events: { click: function(event) {
			// Appel du listener
			self.onclick(self, 0, event.point.x);
			// Si les étiquettes sont affichées, on marque la sélection en gras/souligné
			if (self.showLabels) {
				// Rechercher les "text" correspondant aux étiquettes
				var texts = event.point.dataLabel.element.parentNode.querySelectorAll('.highcharts-label > text');
				var wasSelected = texts[event.point.x].style.fontWeight === 'bold'
					&& texts[event.point.x].style.textDecoration === 'underline';
				// Retirer le gras/souligné sur l'éventuel "text" précédent
				for (var i = 0; i < texts.length; i++) {
					texts[i].style.fontWeight = 'normal';
					texts[i].style.textDecoration = 'none';
				}
				// Ajouter le gras/souligné au "text" correspondant à l'étiquette cliquée si l'élément n'était pas déjà sélectionné
				// Sinon la boucle précédente s'est chargé de lui remettre le style normal
				if (!wasSelected) {
					texts[event.point.x].style.fontWeight = 'bold';
					texts[event.point.x].style.textDecoration = 'underline';
				}
			}
			// Comportement par défaut de Hightchart pour séparer la part cliquée
			event.point.select(!event.point.selected, false);
		}}};
	}
	return Highcharts.chart(div, options);
};

/**
 * Cette méthode crée un diagramme "Barres", "Lignes" ou "Surfaces" avec différentes variantes (empilées, inversées, courbes, ...)
 *
 * @param {HTMLElement} div - le div dans lequel créer le diagramme
 * @param {String} type - le type de diagrammme parmi 'bar', 'column', 'area', 'line' et 'spline'
 * @param {boolean} stacked - indique si les séries sont empilées (valable pour 'bar', 'column' et 'area')
 * @param {boolean} inverted - indique si les axes sont inversées (par exemple lignes verticales au lieu de horizontales)
 */
Diagramme.prototype.internalBuildBarColumnAreaLineSplineChart = function(div, type, stacked, inverted) {
	var self = this;
	// Options du diagrammes
	var options = this.internalBuildChartOptions(type, {
		chart: { inverted: !!inverted, zoomType: 'x' },
		tooltip: {
			positioner: function (labelWidth, labelHeight, point) {
				var x = this.chart.plotLeft + Math.min(this.chart.plotWidth - labelWidth, point.plotX);
				var y = this.chart.plotTop + Math.max(0, point.plotY - labelHeight - 10);
				return { x: x, y: y };
			}
		},
		plotOptions: {},
		xAxis: {
			title: { text: self.hideLevelsLabel ? '' : this.categoriesTitle },
			categories: this.categories
		},
		yAxis: { title: { text: '' }, labels: { format: this.internalGetFormat('value', 'min') } },
		series: this.measures.map(function(measure, index) {
			var serie = {
				name: measure.caption,
				data: self.categories.map(function(c) { return c.values[index]; }),
				tooltip: { valueDecimals: measure.decimals }
			};
			var total;
			if (self.showLabels) {
				// Si demandé, afficher les étiquettes ...
				serie.dataLabels = { enabled: true };
				if (self.showLabelsAsPercentage) {
					// ... en pourcentage (il faut le calculer car HC ne le fournit pas)
					total = serie.data.reduce(function(a, b) { return a + (b || 0); }, 0);
					serie.dataLabels.formatter = function() { return (this.y * 100 / total).toFixed(1) + '%'; };
				} else {
					// ... ou avec le bon nombre de décimales (comportement par défaut)
					serie.dataLabels.format = self.internalGetFormat('y', measure.decimals);
				}
			}
			if (self.showLastMeasureWithLine && (index === self.measures.length - 1)) {
				// Si demandé, forcer l'affichage de la dernière mesure en "ligne"
				serie.type = 'line';
				// forcer un label particulier avec max 1 décimale si les labels généraux des séries sont cachés
				if (! self.showLabels)
					serie.dataLabels = { enabled: true, format: self.internalGetFormat('y', Math.min(1, measure.decimals)) };
			}
			return serie;
		})
	});
	if (stacked)
		options.plotOptions[type] = { stacking: 'normal' };
	this.internalAddSeriesClick(div, options);
	this.internalAddCategoriesClick(div, options);
	return Highcharts.chart(div, options);
};

/**
 * Cette méthode crée un diagramme "Bulles" ou "Points" à partir de 2 mesures (X et Y) et un niveau (points).
 * Pour les bulles, une 3ème mesure donnne la taille des bulles.
 *
 * @param {HTMLElement} div - le div dans lequel créer le diagramme
 * @param {String} type - le type de diagrammme parmi 'bubble' et 'scatter'
 * @param {boolean} useZ - indique si on utilise 3 mesures (bulles) ou uniquement 2 (points)
 */
Diagramme.prototype.internalBuildBubbleScatterChart = function(div, type, useZ) {
	var self = this;
	// On va marquer les valeurs X et Y des totaux, si présents, avec des lignes en pointillés
	var xPlotLines = [], yPlotLines = [], lastCategory = this.categories[this.categories.length - 1];
	if (lastCategory.isTotals) {
		xPlotLines.push({ color: 'black', dashStyle: 'dot', width: 1, value: lastCategory.values[0], zIndex: 3 });
		yPlotLines.push({ color: 'black', dashStyle: 'dot', width: 1, value: lastCategory.values[1], zIndex: 3 });
	}
	var options = this.internalBuildChartOptions(type, {
		chart: { plotBorderWidth: 1, zoomType: 'xy' },
		legend: { enabled: false },
		xAxis: { gridLineWidth: 1, title: { text: this.measures[0].caption }, labels: { format: this.internalGetFormat('value', this.measures[0].decimals) }, plotLines: xPlotLines },
		yAxis: { gridLineWidth: 1, title: { text: this.measures[1].caption }, labels: { format: this.internalGetFormat('value', this.measures[1].decimals) }, plotLines: yPlotLines, startOnTick: false, endOnTick: false },
		plotOptions: { series: { dataLabels: { enabled: this.showLabels, format: '{point.caption}' } } },
		series: [{
			allowPointSelect: true,
			data: this.categories.map(function(category) {
				return { x: category.values[0], y: category.values[1], z: (useZ ? category.values[2] : 0), caption: category.caption };
			})
		}],
		tooltip: {
			headerFormat: '<table>',
			pointFormat: '<tr><th colspan="2"><big>{point.caption}</big></th></tr>' + ['x', 'y', 'z'].map(function(property, index) {
				if (property === 'z' && !useZ)
					return '';
				var format = self.internalGetFormat('point.' + property, self.measures[index].decimals);
				return '<tr><th>' + self.measures[index].caption + ' :</th><td>' + format + '</td></tr>';
			}).join(''),
			footerFormat: '</table>',
			followPointer: false
		},
	});
	// Détecter les clics pour prévenir la page, si demandé
	if (this.onclick) {
		options.plotOptions[type] = { cursor: 'pointer', point: { events: { click: function(event) {
			self.onclick(self, null/*measureIndex non défini car le point concerne 2 ou 3 mesures*/, event.point.index);
		}}}};
	}
	return Highcharts.chart(div, options);
};

/**
 * Ajoute la gestion du clic pour les diagrammes en series (barres, lignes, surfaces, radar, rose, ...).
 *
 * @param {DOM} div - le conteneur du diagramme, pour y retrouver les intitulés de catégorie
 * @param {Object} options - les options destinées à Highchart auxquelles on ajoute la gestion du clic
 */
Diagramme.prototype.internalAddSeriesClick = function(div, options) {
	if (this.onclick) {
		var self = this;
		if (!options.plotOptions)
			options.plotOptions = {};
		if (!options.plotOptions.series)
			options.plotOptions.series = {};
		options.plotOptions.series.cursor = 'pointer';
		options.plotOptions.series.events = { click: function(event) {
			// event.point.select(true, false);
			self.internalSelectCategory(div, this.index, event.point.x);
		}};
	}
};

/**
 * Ajoute la gestion du clic pour les diagrammes avec catogories (pie, barres, surfaces, radar, rose, ...).
 *
 * @param {DOM} div - le conteneur du diagramme, pour y injecter des addEventListener
 * @param {Object} options - les options destinées à Highchart auxquelles on ajoute la gestion du clic
 */
Diagramme.prototype.internalAddCategoriesClick = function(div, options) {
	if (this.onclick) {
		var self = this;
		if (!options.xAxis)
			options.xAxis = {};
		if (!options.xAxis.labels)
			options.xAxis.labels = {};
		if (!options.xAxis.labels.style)
			options.xAxis.labels.style = {};
		// Les catégories sont cliquables
		options.xAxis.labels.style.cursor = 'pointer';
		// On surcharge le formatter pour injecter dans le "tspan" l'index de la catégorie
		options.xAxis.labels.formatter = function() {
			return '<tspan class="category-' + this.pos + '">' + this.value.toString() + '</tspan>';
		};
		// On écoute les clics sur le div pour voir si c'est un clic sur une catégorie
		// J'ai cherché dans les plugins de Highcharts : https://www.highcharts.com/plugin-registry
		// Il n'y avait que "Custom Events" mais il casse tout : https://github.com/blacklabel/custom_events
		// En comme ça peut se faire en quelque ligne, c'est pas plus mal...
		// Tout d'abord, on attendra que le diagramme soit prêt pour ajouter le listener.
		// En effet, on pourrait ajouter le listener sur le "div" mais on ne saurait pas quand le retirer.
		// En l'ajoutant au ".highcharts-container" créé dans "div", on zappe ce problème
		if (!options.chart.events)
			options.chart.events = {};
		options.chart.events.load = function() {
			div.childNodes[0].addEventListener('click', function(event) {
				var measureIndex = null; // clic sur une catégorie mais pas une mesure en particulier
				var categoryText, categoryIndex;
				if (event.target.tagName === 'tspan') {
					categoryText = event.target.getAttribute('class');
					if (categoryText && categoryText.indexOf('category-') === 0) {
						categoryIndex = parseInt(categoryText.substring('category-'.length));
						self.internalSelectCategory(div, measureIndex, categoryIndex);
					}
				}
			}, false);
		};
	}
};

Diagramme.prototype.internalSelectCategory = function(div, measureIndex, categoryIndex) {
	// Appel du listener
	this.onclick(this, measureIndex, categoryIndex);
	// Rechercher les "text" correspondant aux catégories
	var texts = div.querySelectorAll('.highcharts-xaxis-labels > text');
	var selectedTextChild = div.querySelector('.highcharts-xaxis-labels > text tspan.category-' + categoryIndex);
	var wasSelected = selectedTextChild && selectedTextChild.parentNode.style.fontWeight === 'bold'
		&& selectedTextChild.parentNode.style.textDecoration === 'underline';
	// Retirer le gras/souligné sur l'éventuel "text" précédent
	for (var i = 0; i < texts.length; i++) {
		texts[i].style.fontWeight = 'normal';
		texts[i].style.textDecoration = 'none';
	}
	// Ajouter le gras/souligné au "text" correspondant à la catégorie cliquée si l'élément n'était pas déjà sélectionné
	// Sinon la boucle précédente s'est chargé de lui remettre le style normal
	if (selectedTextChild && !wasSelected) {
		selectedTextChild.parentNode.style.fontWeight = 'bold';
		selectedTextChild.parentNode.style.textDecoration = 'underline';
	}
};
